<template>
  <div class="container">
    <request-detail
      :formData="basicInfoData"
      :formModel_R="formModel_R"
      :formModel_S="formModel_S"
      @clickSubmit="clickSubmit"
      :isLoading="isLoading"
    />
    <el-dialog
      title="Bureau LookUp"
      :visible.sync="showModal"
      width="80%"
      @close="handleClickClose"
    >
      <el-form label-position="left" :model="form" v-if="this.isAgBrazil">
        <el-form-item label="CNPJ">
          <el-input v-model="form.cnpj"></el-input>
        </el-form-item>
      </el-form>
      <el-table
        v-else
        :data="bureauTableData"
        style="width: 100%"
        stripe
        height="400"
        ref="selectTable"
        @selection-change="handleTableChange"
      >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column
          :width="column.width"
          :fixed="column.fixed"
          v-for="column in bureauTableModel"
          :prop="column.prop"
          :label="column.label"
          :key="column.prop"
        ></el-table-column>
      </el-table>
      <el-button
        @click="_handleProcess"
        type="primary"
        class="processBtn"
        :loading="loading"
      >
        Process
      </el-button>
    </el-dialog>
    <el-dialog title="Tips" :visible.sync="targetVisible" width="500px">
      <p style="line-height: 40px; word-break: keep-all">{{ targetMessage }}</p>
      <span slot="footer" class="dialog-footer">
        <customize-button @click="handleClickSkip" style="margin-right: 20px">
          Skip
        </customize-button>
        <customize-button type="primary" @click="handleTargetDialog">
          Sure
        </customize-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/config'
import { getCusInfo, creditSubmit, getBureauTable, addCnpj } from './api'
import RequestDetail from '../components/request-detail/request-detail.vue'
let targetParams = {}

const eaasType = {
  label: 'EaaS Type',
  type: 'select',
  key: 'eaasType',
  placeholder: 'All',
  selectList: [
    {
      id: 1,
      name: 'CAPEX',
    },
    {
      id: 2,
      name: 'OPEX',
    },
  ],
  rules: [
    {
      required: true,
      message: 'Cannot be empty',
      trigger: 'change',
    },
  ],
}

export default {
  components: { RequestDetail },
  data() {
    const formModel_R = [
      {
        label: 'Credit Request Type',
        type: 'select',
        key: 'requestType',
        value: 1,
        selectList: [
          {
            id: 1,
            name: 'Line Of Credit',
          },
        ],
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Customer Type',
        type: 'select',
        key: 'customerType',
        placeholder: 'All',
        change: this.handleCustomerTypeChange,
        disabled: true,
        selectList: [
          {
            id: 1,
            name: 'Trade',
          },
          {
            id: 2,
            name: 'Eaas',
          },
          {
            id: 3,
            name: 'Saas',
          },
        ],
        rules: [
          {
            required: true,
            message: 'Cannot be empty',
            trigger: 'change',
          },
        ],
      },
      {
        label: 'Credit Category',
        type: 'select',
        key: 'creditCategory',
        selectList: [
          {
            id: 1,
            name: 'BAU',
          },
          {
            id: 2,
            name: 'Uplift',
          },
          {
            id: 3,
            name: 'Extension',
          },
        ],
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Request Amount($)',
        type: 'input',
        key: 'requestAmount',
        input: value => this.handleChange(value),
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'blur' },
        ],
      },
    ]
    const formModel_S = []
    const bureauTableModel = [
      { prop: 'dunsNumber', label: 'Duns Number', width: 140 },
      { prop: 'registrationNumber', label: 'Registration Number', width: 180 },
      { prop: 'typeDescription', label: 'Type Description', width: 180 },
      { prop: 'businessName', label: 'Business Name', width: 150 },
      { prop: 'address', label: 'Address', width: 180 },
      { prop: 'city', label: 'City', width: 120 },
      { prop: 'state', label: 'State/Province/Region', width: 200 },
      { prop: 'countryCode', label: 'Country Code', width: 150 },
      { prop: 'postalCode', label: 'Postal Code', width: 150 },
      { prop: 'telephone', label: 'Telephone#', width: 140 },
      { prop: 'url', label: 'URL', width: 100 },
      { prop: 'confidenceCode', label: 'Confidence Code', width: 180 },
      { prop: 'matchGrade', label: 'Match Grade', width: 150 },
      {
        prop: 'matchGradeComponentsCount',
        label: 'Match Grade Components Count',
        width: 230,
      },
      { prop: 'matchBasisCount', label: 'Match Basis Count', width: 160 },
      {
        prop: 'matchDataProfileComponentsCount',
        label: 'Match Data Profile Components Count',
        width: 270,
      },
      { prop: 'matchDescription', label: 'Match Description', width: 180 },
      { prop: 'tradeStyle', label: 'Trade Style', width: 130 },
      { prop: 'operatingStatus', label: 'Operating Status', width: 140 },
      { prop: 'isStandalone', label: 'isStandalone', width: 130 },
    ]
    return {
      uploadUrl: `${config.baseApi}/workflow-api/credit-apply/attachment/upload`,
      formModel_R: formModel_R, // 详情页credit request的formModel
      formModel_S: formModel_S,
      allInfo: {}, // 全部对信息数据
      basicInfoKeys: [
        'code',
        'name',
        'businessStr',
        'regionStr',
        'paymentTermReq',
      ], // 不需要所有的数据，根据原型把需要的key挑出来
      basicInfoData: [],
      showModal: false,
      bureauReportId: '',
      bureauTableModel,
      bureauTableData: [],
      multipleSelection: [],
      selectedBureauItem: [],
      loading: false,
      tempParams_: {}, // 再次使用「同一接口」传递不同参数,需保留原已填写的params再次调用接口时使用
      isLoading: false, // submit之后需要给后端2s的时间处理，之后才跳转页面
      form: {
        cnpj: '',
        dunsNumber: '',
      },
      isAgBrazil: true,
      targetVisible: false,
      targetMessage: '',
    }
  },
  mounted() {
    const params = {
      id: this.$route.params.customerId,
    }
    this.$route.params.customerId && this._getCusInfo(params)
  },
  beforeDestroy() {
    this.timer = null
    clearTimeout(this.timer)
    document.title = 'Lenovo Credit Platform'
  },
  methods: {
    handleCustomerTypeChange(val) {
      if (val === 2) {
        this.formModel_R.splice(2, 0, eaasType)
      } else if (val !== 2 && this.formModel_R.length === 5) {
        this.formModel_R.splice(2, 1)
      }
    },
    handleTargetDialog() {
      this.targetVisible = false
      this.targetMessage = ''

      let routeUrl = this.$router.resolve({
        path: `/customer-management/${this.$route.params.customerId}/add-scores?amount=${targetParams?.loanAmount?.amount}`,
      })
      window.open(routeUrl.href, '_blank')
    },
    handleClickClose() {
      this.isLoading = false
    },
    async handleChange(value) {
      value = this.$utils.setSeperatenum(value)
      this.formModel_R = this.formModel_R.map(item => {
        if (item.key === 'requestAmount') {
          item.value = value
        }
        return item
      })
    },
    async _getCusInfo(params) {
      try {
        const res = await getCusInfo(params)
        if (res && res.companyInfoVO) {
          this.formModel_R = this.formModel_R.map((item, index) => {
            if (index === 1) {
              return {
                ...item,
                value: res.companyInfoVO.customerType,
              }
            }
            return item
          })

          this.allInfo = res
          this.filterData(res)
          document.title = res.companyInfoVO.name
          if (res.companyInfoVO.customerType === 2) {
            this.formModel_R.splice(2, 0, eaasType)
          }
        }
      } catch (err) {
        this.$message.error(err)
        await this.$router.push('/credit-management/credit-request/home')
      }
    },
    //对数据进行摘取
    filterData(allData) {
      // 对basic info操作
      if (allData.companyInfoVO) {
        const _basicInfoData = []
        Object.keys(allData.companyInfoVO).forEach(key => {
          if (this.basicInfoKeys.indexOf(key) !== -1) {
            const obj = {}
            obj['key'] = key
            obj['value'] = allData.companyInfoVO[key]
            _basicInfoData.push(obj)
          }
        })
        this.basicInfoData = _basicInfoData
        console.log(this.basicInfoData)
      }
    },
    // 点击事件
    clickSubmit(paramsObj) {
      this.isLoading = true
      const arr = []
      paramsObj.fileList.forEach(item => {
        arr.push(item.response.data)
      })
      try {
        const params = {
          attachmentIds: paramsObj.fileList.length ? arr : [],
          companyId: this.$route.params.customerId,
          loanAmount: {
            amount: this.$utils.resetAmount(paramsObj.amount),
          },
          remark: paramsObj.remark,
          type: paramsObj.type,
          requestType: paramsObj.requestType,
          dunsNumber: '',
          customerType: paramsObj.customerType,
        }
        if (paramsObj.customerType === 2) {
          params.eaasType = paramsObj.eaasType
        }

        this._handleSubmit(params)
      } catch (err) {
        this.isLoading = false
        console.log(err)
      }
    },
    handleClickSkip() {
      this._handleSubmit({ ...targetParams, isSkipLAS: 1 })
    },
    // 提交credit request
    async _handleSubmit(params) {
      if (Object.keys(params).length) {
        targetParams = params
      }
      try {
        const { bureauReportId, success } = await creditSubmit(params)
        this.$message.success('Success')
        if (!success) {
          this.showModal = true
          this.bureauReportId = bureauReportId
          this.tempParams_ = params // 保存原来填写好的params
          // 这是巴西
          if (
            this.allInfo.companyInfoVO.geoStr === 'AG' &&
            this.allInfo.companyInfoVO.regionStr === 'Brazil'
          ) {
            this.isAgBrazil = true
          } else {
            // 不是巴西的
            this.isAgBrazil = false
          }
          await this._getBureauTable(bureauReportId)
        } else {
          this.timer = setTimeout(() => {
            this.isLoading = false
            this.$router.push('/credit-management/credit-request/query')
          }, 1000)
        }
      } catch (e) {
        this.isLoading = false
        this.targetVisible = true
        this.targetMessage = e
        console.log(e)
      }
    },
    // 获取bureau lookup 数据
    async _getBureauTable(bureauId) {
      this.bureauTableData = await getBureauTable(bureauId)
    },
    handleTableChange(val) {
      this.selectedBureauItem = val[0]
      if (val.length > 1) {
        this.$refs.selectTable.clearSelection()
        this.$refs.selectTable.toggleRowSelection(val.pop())
      }
    },
    async _handleProcess() {
      try {
        this.loading = true
        // 这是巴西
        if (
          this.allInfo.companyInfoVO.geoStr === 'AG' &&
          this.allInfo.companyInfoVO.regionStr === 'Brazil'
        ) {
          await addCnpj(this.$route.params.customerId, this.form.cnpj)
        } else {
          console.log('')
        }
        const res = await creditSubmit({
          ...this.tempParams_,
          dunsNumber: this.selectedBureauItem.dunsNumber || '',
        })
        console.log('rrr', res)
        this.loading = false
        this.showModal = false
        this.timer = setTimeout(() => {
          this.loading = false
          this.$router.push('/credit-management/credit-request/query')
        }, 2000)
      } catch (err) {
        this.loading = false
        this.isLoading = false
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  .processBtn {
    margin-top: 20px;
  }
}

/* 去掉全选按钮 */
:deep(.el-table__fixed-header-wrapper .el-table-column--selection) {
  visibility: hidden;
}
</style>
